<template>
  <div class="SinglePageDescription">
    <div class="BookingInstructions-div">
      <van-skeleton title :row="3" title-width="80" :loading="loading">
        <p class="Quick-reply">退改说明</p>
        <div
          v-for="(item, index) in refund_change_rule"
          :key="'info3' + index"
          class="BookingInstructions-padd"
        >
          <p class="BookingDetails-title">
            {{ item.key }}
          </p>
          <p v-html="item.value" class="BookingDetails-content"></p>
        </div>
        <p
          v-if="
            refund_change_rule == '' ||
            refund_change_rule == null ||
            refund_change_rule == []
          "
          class="BookingDetails-information"
        >
          暂无信息
        </p>
      </van-skeleton>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      refund_change_rule: [],
      loading: true,
    };
  },
  mounted() {
    this.TicketDetails();
  },
  methods: {
    TicketDetails() {
      this.$api
        .post("third-tickets/member/ticket/detail", {
          short_name: "PanHe",
          product_id: this.$route.query.product_id,
        })
        .then((res) => {
          //退改说明
          this.loading = false;
          this.refund_change_rule = res.refund_change_rule;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.SinglePageDescription {
  background: #fff;
  .van-skeleton {
    margin-top: 30px;
    padding-bottom: 10px;
    .van-skeleton__title {
      width: 90px;
       height: 25px;
      border-radius: 20px;
    }
    .van-skeleton__content {
      border-radius: 20px;
    }
    .van-skeleton__row {
      //  height: 50px;
      // margin: 17px 0px;
      border-radius: 20px;
    }
  }
  .Quick-reply {
    color: #333;
    font-weight: bold;
    padding-top: 25px;
    margin-bottom: 15px;
    padding-left: 20px;
  }
  .BookingInstructions-div {
    border-bottom: 5px solid #f3f8fb;
    padding-bottom: 20px;

    .BookingDetails-information {
      color: #666;
      font-size: 13px;
      font-weight: bold;
      padding-left: 20px;
    }
    .BookingInstructions-padd {
      padding: 0px 20px;
      margin-top: 20px;
      border-bottom: 1px solid #efefef;
      padding-bottom: 15px;
    }
    .BookingInstructions-padd:last-of-type {
      border-bottom: none;
    }
  }

  .BookingDetails-title {
    color: #333;
    font-size: 13px;
    font-weight: bold;
  }

  .BookingDetails-content {
    font-size: 13px;
    color: #999;
    line-height: 20px;
    background: #fff;

    margin-top: 10px;
    /deep/ img {
      width: 100%;
      margin: 10px 0px;
    }
  }
}
</style>
